import "./tablestyle.scss";
import {
  Grid,
  GridCellProps,
  GridNoRecords,
  GridHeaderCellProps,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import { checkcompanySize, checkCompanyType,  companyApprovalAccess} from "../../utils/EllowUtils";
import Button from "../../components/button";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import ApproveOrReject from "../../modal/company";
import { orderBy, SortDescriptor } from "@progress/kendo-data-query";

interface ProductNameHeaderProps extends GridHeaderCellProps {
  children: any
}



const ProviderTable = (props: any) => {
  const initialSort: Array<SortDescriptor> = [{ field: "", dir: "asc" }];

  const [sort, setSort] = useState(initialSort);
  const [modal, setModal] = useState<boolean>(false)
  const [rejectModal, setRejectModal] = useState<boolean>(false)
  const [data , setData] = useState<any>()

  const InterviewCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.scheduleDate ? new Date(parseInt(props.dataItem.scheduleDate)).toDateString() : 'Not Available'}
      </td>
    )
  }

  const serviceOffered = (props: GridCellProps) => {

  let length = props.dataItem.services && props.dataItem.services.length;
    return (
      <td >
         <div className="skillsWrap">
          {props.dataItem.services && props.dataItem.services.map((item: any, key: number)  => {
             return ((item) + (key < length - 1 ? ' , ' : ''))})}
        </div>
      </td>
    );
  };

  const skillsCell = (props: GridCellProps) => {

    let length = props.dataItem.skills && props.dataItem.skills.length;
  
    return (
      <td >
         <div className="skillsWrap">
          {props.dataItem.skills && props.dataItem.skills.map((item: any, key: number)  => {
             return ((item) + (key < length - 1 ? ' , ' : ''))
          })}
        </div>
      </td>
    );
  }

  const phoneCell = (props: GridCellProps) => { 
    return <td className="break-all" >
      {props && props.dataItem && props.dataItem.phoneNumber ? props.dataItem.phoneNumber : 'NA'}
    </td>;
  }

  const dateCell = (props: GridCellProps) => {
    let date = props.dataItem.dateOfReg
      ? new Date(parseInt(props.dataItem.dateOfReg)).toDateString().slice(3)
      : ""
    return <td>{date}</td>
  }

  const domainsCell = (props: GridCellProps) => {
    let length = props.dataItem.domains && props.dataItem.domains.length;

    return (
      <td >
         <div className="skillsWrap">
          {props.dataItem.domains && props.dataItem.domains.map((item: any, key: number)  => {
             return ((item) + (key < length - 1 ? ' , ' : ''))})}
        </div>
      </td>
    );
  };

  const  customerStatus = (data: any) => {
    
    let companyApprovalRejectAccess  = companyApprovalAccess(data.companyType)

    if(data.rejectComment){
      setData(data)
      if(  companyApprovalRejectAccess === true ){
        setRejectModal(true)
      }
    }else{
      setData(data)
      if(companyApprovalRejectAccess === true ){
        setModal(true)
      }
    }
  }

  const submitCustomerStatus = (value: any) => {    
    if(value === undefined){
      setModal(false)
      props.approveOrRejectCustomer(data) 
    }else{
      setRejectModal(false)
      data.rejectComment = value.rejectComment
      props.approveOrRejectCustomer(data) 
    }
  }

  const locations = (props: GridCellProps) => {
    
    return ( 
      <td>
        {props.dataItem.googleLocations ? props.dataItem.googleLocations.map((item: any, key:number) => {
          return(
            <div  key={key} className="positionList">
              <span className="status warning" />
              <strong>{item.name}</strong>    
            </div>
          )
        }) : 'Not Mentioned'}
      </td>
    )
  }

  return (
    <>
      <Grid
        data={props.state.items}
        onPageChange={props.pageChange}
        total={props.state.total}
        skip={props.state.skip}
        pageable={props.state.pageable}
        pageSize={props.state.pageSize}
        sortable={true}
        sort={sort}
        onSortChange={(e) => {
          setSort(e.sort);
          props.setSort(e.sort);
          props.applySort(e.sort);
        }}
      >
        <GridNoRecords>
                    <div className="noData">
                        <Icon icon="mdi:smiley-neutral-outline" />
                        No data to display
                    </div>
                </GridNoRecords>
        <Column field="companyName" title="Company" cell={nameCell}/>
        <Column field="firstName" title="Name" />
        <Column field="email" title="Email" className="break-all" />
        <Column field='phoneNumber' title="Mobile" />
        {/* <Column field="scheduleDate" title="Call Details" cell={InterviewCell}/> */}
        <Column field="serviceOffered " title="Service Offered" className="break-all" cell={serviceOffered}/>
        <Column field="skills " title="Skills Offered" className="break-all" cell={skillsCell}/>
        <Column field="domains" title="Domains" width="150px" cell={domainsCell}/>
        <Column field="dateOfRegistration" title="Date of Registration" width="150px" cell={dateCell}/>
        <Column field="companyType" title="Type"  cell={(props: GridCellProps) => companyType(props)}/>
        <Column field="googleLocations" title="Locations" cell={locations}/>
        <Column field="status" title="Status" width="150px" cell={(props: GridCellProps) => statusCell(props, (data: any) => customerStatus(data))}/>

      </Grid>
      {/* {modal && <ApproveOrReject onClose={ () => setModal(false)} submitCustomerStatus={submitCustomerStatus}/>} */}
      {modal && <ApproveOrReject onClose={ () => setModal(false)} submitCustomerStatus={submitCustomerStatus} reject={false}/>}
    {rejectModal && <ApproveOrReject onClose={ () => setRejectModal(false)} submitCustomerStatus={submitCustomerStatus} reject={true}/>}
    </>
  );
};
export default ProviderTable;

const nameCell = (props: GridCellProps) => {
  const openInNewTab = (url: any) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  let currentDate = new Date().getTime()
  let dateOfRegistration = props.dataItem.dateOfReg
  var diff =(currentDate -  dateOfRegistration) / 1000;
  diff /= (60 * 60);
  let diff2 = Math.abs(Math.round(diff)) 

  const onClick = (data: any) => {
    localStorage.setItem('CompanySettings', JSON.stringify(data))
    openInNewTab(`${window.location.origin}/companysettings`)
  }
  return (
    <td className="statusWrap">
      {diff2 <= 24 &&
        <span className="userStatus">New</span>
      }
      <div onClick={() => onClick(props.dataItem)}>{props && props.dataItem && props.dataItem.companyName ? props.dataItem.companyName : 'NA'}</div>
    </td>
  )
}

const statusCell = (props: GridCellProps , customerStatus: any) => {
  
  const userLoginId = localStorage.getItem('loginId')
  const approve = () => {
      let value = {
        "customerId": props.dataItem.companyId,
        "userLoginId": userLoginId,
        "customerStatus": 4,
        "companyType":  props.dataItem.companyType,
        "customerName": props.dataItem.companyName,
        "userId": props.dataItem.userId
      }
      customerStatus(value)
  }
  
  const reject = () => {
    let value = {
      "customerId": props.dataItem.companyId,
      "userLoginId": userLoginId,
      "customerStatus": 5,
      "companyType":  props.dataItem.companyType,
      "customerName": props.dataItem.companyName,
      "userId": props.dataItem.userId,
      "rejectComment": " "
    }
    customerStatus(value)
  }
  return (
    <td>
      <div className="likeAndDislike">
        <Button onClick={approve}><Icon icon="bx:like" /></Button>
        <Button onClick={reject}><Icon icon="bx:dislike" className="dislike"/></Button>
      </div>
    </td>
  )
}

const companyType = (props: GridCellProps) => {
  return <td>{checkCompanyType(props.dataItem.companyType)}</td>;
}
